import { Avatar, Box, Grid, Stack, Typography } from "@mui/material";
import MicIcon from "@mui/icons-material/Mic";
import ImageIcon from "@mui/icons-material/Image";
import dayjs from "dayjs";
import moment from "moment";
import { useEffect, useState } from "react";

const extractMessageUrl = (text) => {
  if (typeof text === "string" && text.trim().startsWith("{")) {
    try {
      return JSON.parse(text.trim())?.url || "";
    } catch (e) {
      return text;
    }
  }
  return text || "";
};

const AccountListing = ({
  fromUserDetails,
  messageDetails,
  groupUsers = [],
  color,
  groupDetails = {},
  onChatClick,
  clientColor,
  isSelected,
  loginData
}) => {
  const { chatGroupId = 0, groupName: passedGroupName = "" } = groupDetails;

  const { unreadMessagesNr, dateSent, messageText, typeId } = messageDetails || {};
  const { firstName: fromFirstName, id } = fromUserDetails || {};

  const getMediaType = (text) => {
    const url = extractMessageUrl(text);
    if (typeId === 4 || /\.(mp3|wav|m4a|ogg|aac)(\?.*)?$/i.test(url)) return "audio";
    if (/\.(jpeg|jpg|gif|png|webp)(\?.*)?$/i.test(url)) return "image";
    return "text";
  };

  const getPreviewText = (text) => {
    const mediaType = getMediaType(text);
    if (mediaType === "audio") return "Voice Message";
    if (mediaType === "image") return "Photo";
    return text;
  };

  // const groupIcon = groupDetails?.groupIcon;
  const [groupName, setGroupName] = useState("");
  const [groupIcon, setGroupIcon] = useState("");
  function getGroupIcon() {
    const { pictureUrl } = groupUsers[0] || {};
    return pictureUrl;
  }

  function getChatGroupName() {
    const memberLength = groupUsers.length;
    let chatListTitle = "";

    if (memberLength > 1) {
      if (memberLength == 2) {
        const { firstName: firstMemberFirstName = "" } = groupUsers[0] || {};
        const { firstName: secondMemberFirstName = "" } = groupUsers[1] || {};
        chatListTitle = firstMemberFirstName + " & " + secondMemberFirstName;
        return chatListTitle;
      }

      if (memberLength > 2) {
        const { firstName: firstMemberFirstName = "" } = groupUsers[0] || {};
        const { firstName: secondMemberFirstName = "" } = groupUsers[1] || {};
        chatListTitle = firstMemberFirstName + ", " + secondMemberFirstName;
        if (memberLength == 3) {
          chatListTitle = chatListTitle + " & 1 " + "other";
        } else if (memberLength > 3) {
          chatListTitle = chatListTitle + ` ${memberLength - 2}` + " " + "others";
        }
        return chatListTitle;
      }
    } else {
      const { firstName = "", lastName = "" } = groupUsers[0] || {};
      return (chatListTitle = firstName + " " + lastName);
    }
  }

  useEffect(() => {
    setGroupIcon(getGroupIcon());
    if (passedGroupName.length > 0) {
      setGroupName(passedGroupName);
    } else {
      setGroupName(getChatGroupName());
    }
  }, []);
  const getGroupName = () => {
    if (passedGroupName) return passedGroupName;

    const memberLength = groupUsers.length;
    if (memberLength === 1) {
      return groupUsers[0]?.firstName || "";
    }

    const names = groupUsers
      .slice(0, 2)
      .map((user) => user?.firstName)
      .filter(Boolean);
    let groupName = names.join(", ");

    if (memberLength > 2) {
      groupName += ` & ${memberLength - 2} others`;
    }
    return groupName;
  };

  const getLatestMessage = () => {
    const preview = getPreviewText(messageText);
    return fromFirstName && messageText ? `${fromFirstName}: ${preview}` : preview;
  };

  function getLatestMsgDetails() {
    let msgDetails = "";
    if (fromFirstName != "undefined" && messageText != "") {
      const preview = getPreviewText(messageText);
      if (loginData?.userInformation?.UserId === id) {
        msgDetails = "Me" + " : " + preview;
      } else {
        msgDetails = fromFirstName + " : " + preview;
      }
    }
    return msgDetails;
  }

  const getMyText = (date) => {
    if (!moment.isMoment(date)) date = moment(date);
    if (date.isSame(moment(), "day")) {
      return moment.parseZone(date).local().format("h:mma");
    } else if (date.isSame(moment().subtract(1, "d"), "day")) {
      return "Yesterday";
    } else if (date.isSame(moment(), "week")) {
      return moment.parseZone(date).local().format("dddd");
    } else {
      return moment.parseZone(date).local().format("YYYY-MM-DD");
    }
  };
  return (
    <Grid size={{ xs: 12 }}>
      <Stack
        direction="row"
        p={1.5}
        alignItems="center"
        spacing={2}
        sx={{
          border: isSelected ? "1px solid #1976d2" : "1px solid #e0e0e0",
          backgroundColor: isSelected ? "#e3f2fd" : "white",
          borderRadius: "12px",
          cursor: "pointer",
          marginBottom: "8px",
          transition: "all 0.2s ease-in-out",
          "&:hover": {
            backgroundColor: isSelected ? "#e3f2fd" : "#f5f5f5",
            transform: "translateY(-1px)",
            boxShadow: "0 2px 4px rgba(0,0,0,0.05)"
          }
        }}
        onClick={() => onChatClick(groupDetails)}>
        <Avatar
          src={groupIcon}
          sx={{
            width: 48,
            height: 48,
            backgroundColor: groupIcon ? "transparent" : clientColor,
            border: "1px solid #f0f0f0"
          }}
        />

        <Stack
          flex={1}
          sx={{
            minWidth: 0 // Crucial for text truncate to work in flex child
          }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" mb={0.5}>
            <Typography variant="subtitle2" sx={{
              fontWeight: 500,
              fontSize: "0.95rem",
              color: "#333",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              flex: 1,
              minWidth: 0,
              mr: 1
            }}>{getGroupName()}</Typography>
            <Box sx={{ whiteSpace: "nowrap", flexShrink: 0 }}>
              {unreadMessagesNr > 0 ? (
                <Stack
                  sx={{
                    backgroundColor: color || "#d32f2f",
                    borderRadius: "50%",
                    width: "20px",
                    height: "20px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "white",
                    boxShadow: "0 1px 2px rgba(0,0,0,0.2)"
                  }}>
                  <Typography variant="caption" sx={{ fontSize: "0.65rem", fontWeight: "bold" }}>
                    {unreadMessagesNr > 99 ? "99+" : unreadMessagesNr}
                  </Typography>
                </Stack>
              ) : (
                dateSent ? (
                  <Typography variant="caption" color="textSecondary" sx={{ fontSize: "0.75rem" }}>
                    {getMyText(moment(dateSent))}
                  </Typography>
                ) : null
              )}
            </Box>
          </Stack>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Stack direction="row" alignItems="center" spacing={0.5} sx={{ minWidth: 0 }}>
              {getMediaType(messageText) === "audio" && (
                <MicIcon sx={{ fontSize: 16, flexShrink: 0, color: "#888" }} />
              )}
              {getMediaType(messageText) === "image" && (
                <ImageIcon sx={{ fontSize: 16, flexShrink: 0, color: "#888" }} />
              )}
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{
                  maxWidth: "200px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  fontSize: "0.85rem",
                  color: isSelected ? "#1565c0" : "#666"
                }}>
                {getLatestMsgDetails()}
              </Typography>
            </Stack>
            {unreadMessagesNr > 0 && dateSent && (
              <Typography variant="caption" color="textSecondary" sx={{ fontSize: "0.7rem" }}>
                {getMyText(moment(dateSent))}
              </Typography>
            )}
          </Stack>
        </Stack>
      </Stack>
    </Grid >
  );
};

export default AccountListing;
